module.exports = __webpack_public_path__ + "img/bca.a646e0cd.png";